import React from 'react';
import { SideDrawerButtonContainer } from '../../v2BaseComponents/Form/SideDrawerFormContainer';
import { getIntl } from '../../../utils/intl';
import useNotes from '../../../hooks/api/useNotes';
import EmailListConfiguration from '../EmailListConfiguration';

const intl = getIntl('send-note-side-drawer-content', {
    share: 'Share Note',
});

export type SendNoteSideDrawerContentOwnProps = {
    noteId: string;
    medicalProfileId: string | null;
    onClose: (force: boolean) => void;
};

export type SendNoteSideDrawerContentProps = SendNoteSideDrawerContentOwnProps;

const SendNoteSideDrawerContent: React.FC<SendNoteSideDrawerContentProps> = (props) => {
    const [emails, setEmails] = React.useState<string[]>([]);
    const { sendNoteEmail, isSendingNoteEmail } = useNotes({
        noteId: props.noteId,
        onSendNoteEmailSuccess: () => {
            props.onClose(true);
        },
    });
    return (
        <SideDrawerButtonContainer
            buttons={[
                {
                    title: intl('share'),
                    variant: 'primary',
                    onPress: () => {
                        sendNoteEmail({
                            noteId: props.noteId,
                            emails,
                        });
                    },
                    isDisabled: !emails.length || isSendingNoteEmail,
                    testID: 'send-note-button',
                    icon: 'Send',
                },
            ]}
        >
            <EmailListConfiguration value={emails} onChange={setEmails} medicalProfileId={props.medicalProfileId} />
        </SideDrawerButtonContainer>
    );
};

export default React.memo(SendNoteSideDrawerContent);
